import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class GeneralStatusService {
  base_url: string = environment.api_url;
  baseHistoryUrl: string = environment.url;

  alarmStatus: string = `${this.base_url}/v1/install/alarms/counts/`;

  alarmsHistory: string = `${this.baseHistoryUrl}/v1/history`;

  osInfo: string = `${this.base_url}/v1/utils/os_info`;

  constructor(private http: HttpClient, private router: Router) {}

  getAlarms(ids: any): Observable<any> {
    return this.http.get<any>(`${this.alarmStatus}${ids}`).pipe(
      catchError((error) => {
        console.error('Error fetching alarms:', error);
        return throwError(error);
      })
    );
  }

  getHistoryAlarms(installations: string, hours: number): Observable<any> {
    return this.http
      .get<any>(`${this.alarmsHistory}/${installations}/${hours}`)
      .pipe(
        catchError((error) => {
          console.log('Error recibido:', error);
          if (error.status === 403) {
            console.log('Redirigiendo a error-404');
            this.router.navigate(['/error-404']);
          }
          return throwError(() => error);
        })
      );
  }

  getServerStats(): Observable<any> {
    return this.http.get<any>(this.osInfo).pipe(
      catchError((error) => {
        console.error('Error fetching alarms:', error);
        return throwError(error);
      })
    );
  }
}
